import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/MarketplaceCampaignTotalDaily.graphql';
import { Query, QuerymarketplaceCampaignReportArgs } from '../../__generated__/globalTypes';

export const useMarketplaceCampaignTotalDailyQuery = (
  options?: QueryHookOptions<Query, QuerymarketplaceCampaignReportArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerymarketplaceCampaignReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useMarketplaceCampaignTotalDailyLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerymarketplaceCampaignReportArgs>
): QueryResult<Query, QuerymarketplaceCampaignReportArgs> & {
  getMarketplaceCampaignTotalDaily: LazyQueryExecFunction<Query, QuerymarketplaceCampaignReportArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getMarketplaceCampaignTotalDaily, result] = useLazyQuery<Query, QuerymarketplaceCampaignReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getMarketplaceCampaignTotalDaily, ...result };
};

export const useMarketplaceCampaignTotalDailyPromiseQuery = () => {
  const client = useApolloClient();

  const getMarketplaceCampaignTotalDaily = useCallback(
    (options?: Omit<QueryOptions<QuerymarketplaceCampaignReportArgs, Query>, 'query'>) =>
      client.query<Query, QuerymarketplaceCampaignReportArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getMarketplaceCampaignTotalDaily };
};
// Suspense Query Hooks
export const useMarketplaceCampaignTotalDailySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerymarketplaceCampaignReportArgs>
) => {
  const result = useSuspenseQuery<Query, QuerymarketplaceCampaignReportArgs>(QUERY, {
    ...options
  });

  return result;
};
